import UsuarioRepository from '@/services/UsuarioRepository'
import { COOKIE_DOMAIN, COOKIE_NAME, COOKIE_SECURE } from '@/config'

export default {
  namespaced: true,
  state: {
    token: '',
    debeCambiarPin: false
  },
  getters: {
    isAuthSet: (state, getters, rootState) => {
      return state.token && rootState.user.nombreOperador
    },

    isLoggedIn: (state) => {
      return !!state.token
    },

    getToken: (state) => {
      return state.token
    }
  },
  mutations: {
    setAuth (state, [token, debeCambiarPin]) {
      state.token = token
      state.debeCambiarPin = debeCambiarPin

      localStorage.setItem('token', token)
      localStorage.setItem('debeCambiarPin', JSON.stringify(debeCambiarPin))
    },

    restoreAuth (state) {
      state.token = localStorage.getItem('token')
      state.debeCambiarPin = JSON.parse(localStorage.getItem('debeCambiarPin'))
    },

    unsetAuth (state) {
      state.token = ''
      state.debeCambiarPin = false

      localStorage.removeItem('token')
      localStorage.removeItem('debeCambiarPin')
      localStorage.removeItem('nombreOperador')
    },

    removeToken (state) {
      // Remove token on 401 response
      state.token = ''

      localStorage.removeItem('token')
    },

    setDebeCambiarPinFalse (state) {
      state.debeCambiarPin = false

      localStorage.setItem('debeCambiarPin', JSON.stringify(false))
    }
  },
  actions: {
    async login ({ commit, dispatch }, [codigoAcceso, pin, domain]) {
      const data = await UsuarioRepository.login(codigoAcceso, pin, domain)
      commit('setAuth', [data.token, data.debe_cambiar_pin])
      commit('user/setUserName', [data.nombre_entidad, codigoAcceso], { root: true })
      await dispatch('setCookie')
    },

    async loginToken ({ commit, dispatch }, [codigoAcceso, token]) {
      const data = await UsuarioRepository.loginToken(codigoAcceso, token)
      commit('setAuth', [data.token, data.debe_cambiar_pin])
      commit('user/setUserName', [data.nombre_entidad, codigoAcceso], { root: true })
      await dispatch('setCookie')
    },

    // Called from router
    restoreAuth ({ commit }) {
      commit('restoreAuth')
      commit('user/restoreUserName', null, { root: true })
    },

    async logout ({ commit, dispatch }) {
      try {
        await UsuarioRepository.logout()
      } finally {
        commit('unsetAuth')
        commit('user/unsetUser', null, { root: true })
        await dispatch('unsetCookie')
      }
    },

    async changePin ({ commit, dispatch }, [pinActual, pinNuevo]) {
      await UsuarioRepository.cambiarPin(pinActual, pinNuevo)
      commit('setDebeCambiarPinFalse')
      await dispatch('setCookie')
    },

    setCookie ({ state, rootState }) {
      // Only set domain cookie if pin doesn't need to be changed
      if (!state.debeCambiarPin) {
        let data = {
          token: state.token,
          codigoAcceso: rootState.user.codigoAcceso,
          nombreOperador: rootState.user.nombreOperador
        }

        // Base64 encode
        // Decode with JSON.parse(decodeURIComponent(window.atob(data)))
        data = window.btoa(encodeURIComponent(JSON.stringify(data)))

        window.$cookies.set(COOKIE_NAME, data, 0, '/', COOKIE_DOMAIN, COOKIE_SECURE)
      }
    },

    unsetCookie () {
      window.$cookies.remove(COOKIE_NAME, '/', COOKIE_DOMAIN)
    },

    unsetAuth ({ commit }) {
      commit('unsetAuth')
    }
  }
}
